import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditProjectResourceRequestFailure({ uuid }) {
      const state = getState().find(
        ({ projectResource }) => uuid === projectResource.uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isEditProjectResourceRequestPending({ uuid }) {
      const state = getState().find(
        ({ projectResource }) => uuid === projectResource.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isEditProjectResourceRequestSuccess({ uuid }) {
      const state = getState().find(
        ({ projectResource }) => uuid === projectResource.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
